module.exports = {"title":{"en":"Technical Error","de":"Technischer Fehler","ro":"Eroare tehnică"},"alert":{"en":"Technical error","de":"Technischer Fehler","ro":"Eroare tehnică"}}


//////////////////
// WEBPACK FOOTER
// ./src/localization/localization-technicalError.json
// module id = 111
// module chunks = 0